import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function getSubAgencies(agencyId) {
	return axios.get(`${SERVER_URL}/api/Agencies/${agencyId}/subAgencies`)
    .then(({ data }) => data);
}

export function createSubAgency(agencyId, subAgencyData) {
  return axios.post(`${SERVER_URL}/api/Agencies/${agencyId}/subAgencies`, subAgencyData)
    .then(({ data }) => data);
}

export default { getSubAgencies, createSubAgency };



// WEBPACK FOOTER //
// ./src/modules/services/sub-agency.service.js